var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xEB\xA1\x9C\xEA\xB7\xB8\xEC\x95\x84\xEC\x9B\x83, \xEC\x83\x81\xED\x83\x9C=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.61029 3H4.67647C4.23184 3 3.80543 3.17516 3.49103 3.48693C3.17663 3.79871 3 4.22158 3 4.6625V14.6375C3 15.0784 3.17663 15.5013 3.49103 15.8131C3.80543 16.1248 4.23184 16.3 4.67647 16.3H7.61029M7.81865 9.65H17.3187M17.3187 9.65L13.6887 5.85M17.3187 9.65L13.6887 13.45",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/Icon_logout.5736fd9747fc38aa25c62f5107f523e8.svg";
export { ForwardRef as ReactComponent };